export const AMOUNT_PATTERN = /^\s*[\d.]*(,\d{1,2})?\s*$/;

export const validateAmountPattern = (value?: string, emptyAllowed = true) => {
  const parsedAmount = value?.trim() ?? "";
  if (!parsedAmount) {
    return emptyAllowed;
  }
  return AMOUNT_PATTERN.test(parsedAmount);
};

export const parseAmount = (value: string, defaultValue = Number.NaN) => {
  if (!validateAmountPattern(value, false)) {
    return defaultValue;
  }
  return parseFloat(value.replace(/\./g, "").replace(",", ".").trim() ?? "");
};

export const adjustAmountValue = (value: string, decimals: number = 2) => {
  if (!validateAmountPattern(value, false)) {
    return value;
  }
  const parsedAmount = parseFloat(value?.replace(/\./g, "").replace(",", ".").trim() ?? "");
  if (isNaN(parsedAmount)) {
    return value;
  }
  return Intl.NumberFormat("de-DE", {
    style: "decimal",
    minimumFractionDigits: decimals,
  }).format(parsedAmount);
};
